import { CardServicePanel } from "./CardServicePanel";

import '../../styles/OServices.css';

export function OServices({ oservices }) {
  return(
    <div id="oservices">
      <section className="hero is-small is-warning">
        <div className="hero-body">
          <h2 className="subtitle is-2 bf-sub-title">{oservices.title}</h2>
        </div>
      </section>

      <div className="text-oservices-container-background m-6">
        <p className="card-content is-size-5 has-text-centered">{oservices.text}</p>
      </div>

      <div className="mb-6">
        <CardServicePanel links={oservices.links}/>
      </div>
    </div>
  );
}